export const transtaion = {
    en: {
        layout: {
            navbar: {
                custom_keywords: '"Custom" Keywords',
                list_keywords: '"List" Keywords',
                questions_keywords: '"Questions" Keywords',
                year_keywords: '"Year" Keywords',
                algo_comparison: 'Algo Comparison',
                all_domains: 'All Domains',
                authors: 'Authors',
                ctr_per_position: 'CTR Per Position',
                categories: 'Categories',
                commerce: 'Commerce',
                competitive_analysis: 'Competitive Analysis',
                countries: 'Countries',
                directories: 'Directories',
                discover: 'Discover',
                discover_analytics: 'Discover Analytics',
                discover_entity_tracking: 'Discover Entity Tracking',
                discover_tracking: 'Discover Tracking',
                entities: 'Entities',
                entity_clusters: 'Entity Clusters',
                evergreen: 'Evergreen',
                evergreen_urls: 'Evergreen URLs',
                google_surfaces: 'Google Surfaces',
                keyword_clusters: 'Keyword Clusters',
                keywords: 'Keywords',
                manual_keyword_lists: 'Manual Keyword Lists',
                manual_url_lists: 'Manual URL Lists',
                opportunities: 'Opportunities',
                overview: 'Overview',
                pages: 'Pages',
                position_distribution: 'Position Distribution',
                seo_recommendations: 'SEO Recommendations',
                search_analytics: 'Search Analytics',
                search_appearance: 'Search Appearance',
                search_appearances: 'Search Appearances',
                stats: 'Stats',
                striking_distance: 'Striking Distance',
                subdomains: 'Subdomains',
                tools: 'Tools',
                url_explorer: 'URL explorer',
                urls: 'URLs',
            },
        },
    },
};
